// 手机买票——微信，主流程
const wxMainRoutes = Array.from({ length: 21 }, (_, i) => ({
  path: `train/wx/index${i + 1}`,
  name: `trainWxIndex${i + 1}`,
  component: () => import(`@/views/traffic/train/wx/index${i + 1}.vue`)
}))



// 手机买票——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 22 }, (_, i) => ({
  path: `train/zfb/index${i + 1}`,
  name: `trainZfbIndex${i + 1}`,
  component: () => import(`@/views/traffic/train/zfb/index${i + 1}.vue`),
}));




// 手机买票——铁路12306，主流程
const tlMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `train/tl/index${i + 1}`,
  name: `trainTlIndex${i + 1}`,
  component: () => import(`@/views/traffic/train/tl/index${i + 1}.vue`),
}));


export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机买票——微信，开始
    ...wxMainRoutes,

    // 手机买票——支付宝，主流程
    ...zfbMainRoutes,

    // 手机买票——铁路12306，主流程
    ...tlMainRoutes,

  ],
};
